var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 13,
    viewBox: "0 0 6 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.995537 0.498475C1.12361 0.498039 1.25016 0.526306 1.36588 0.581197C1.48159 0.636089 1.58354 0.716211 1.66423 0.815675L5.80497 5.95946C5.93107 6.11286 6 6.30527 6 6.50384C6 6.70241 5.93107 6.89483 5.80497 7.04823L1.51849 12.192C1.37297 12.3671 1.16387 12.4772 0.937177 12.4981C0.710485 12.519 0.484775 12.449 0.3097 12.3035C0.134626 12.1579 0.0245285 11.9488 0.00362771 11.7221C-0.017273 11.4955 0.0527352 11.2697 0.198252 11.0947L4.03037 6.49955L0.326846 1.90444C0.222013 1.7786 0.15542 1.62537 0.134949 1.46287C0.114477 1.30037 0.140982 1.13541 0.211328 0.987499C0.281674 0.839591 0.392917 0.71493 0.531894 0.628266C0.67087 0.541602 0.831764 0.496562 0.995537 0.498475Z",
    fill: "#2E3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmall);
export default __webpack_public_path__ + "static/media/arrow-small.3928d597a73c7f5e02b9b68a934cab1e.svg";
export { ForwardRef as ReactComponent };